/**
 * @typedef {Object} AggregateConditionContentProps
 * @property {string} dashboardId
 * @property {string} corporationNumber
 * @property {string} mode
 * @property {string} accPeriod
 * @property {string} fiscalPeriod
 * @property {string} periodType
 */

import { useCallback, useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { fetchMessageTemplates } from './extra/services'

/** @type {React.FC<AggregateConditionContentProps>} */
const AggregateConditionContent = (props) => {
  const { dashboardId, mode, fiscalPeriod, periodType, corporationNumber, accPeriod } = props

  const [messages, setMessages] = useState(null)

  const init = useCallback(async () => {
    try {
      const messages = await fetchMessageTemplates(corporationNumber, {
        dashboardId,
        mode,
        accPeriod,
        fiscalPeriod,
        periodType
      })

      setMessages(messages)
    } catch (e) {
      setMessages(null)
    }
  }, [dashboardId, mode, fiscalPeriod, periodType, corporationNumber])

  useEffect(() => {
    init()
  }, [init])

  if (!messages) return null

  return (
    <div className="px-10 py-5 rounded-xl mt-3 bg-white">
      <h2 className="text-lg mb-3 font-bold">集計条件</h2>

      <ul className="pl-5 list-disc">
        {(messages || null)?.map((e, index) => (
          <li key={index} className="text-sm">
            {e}
          </li>
        ))}
      </ul>
    </div>
  )
}

/** @type {React.FC<AggregateConditionContentProps>} */
export default (props) => {
  const env = process.env.REACT_APP_ENV

  const state = useSelector((s) => {
    const corporationNumber = s.company.corporationNumber
    return {
      corporationNumber,
      privateS3: `chrofy-${env}-${corporationNumber}`,
      mode: s.analysis.mode,
      accPeriod: s.company.accPeriod
    }
  }, shallowEqual)

  const _props = {
    dashboardId: props.dashboardId,
    periodType: props.periodType,
    fiscalPeriod: props.fiscalPeriod,
    accPeriod: state.accPeriod,
    mode: state.mode,
    ...state
  }

  return <AggregateConditionContent {..._props} />
}
